// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "2df837b86a6cfac13d1e294e8c61229a" + ".css";
};